// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* ── ChipArrayInput ──────────────────────────────────────────────────────── */

.chip-array-input {
  display: flex;
  flex-direction: column;
  gap: 4px;
}

.chip-array-input__label {
  font-size: 12px;
  font-weight: 600;
  color: #374151;
  margin: 0;
}

.chip-array-input__required {
  color: #d32f2f;
}

.chip-array-input__field {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 6px;
  min-height: 40px;
  padding: 6px 10px;
  border: 1px solid #d1d5db;
  border-radius: 8px;
  cursor: text;
  background: #fff;
  transition: border-color 0.15s, box-shadow 0.15s;
}

.chip-array-input__field:focus-within {
  border-color: #00a651;
  box-shadow: 0 0 0 2px rgba(0, 166, 81, 0.15);
}

.chip-array-input--error .chip-array-input__field {
  border-color: #d32f2f;
}

.chip-array-input__text {
  flex: 1 1;
  min-width: 140px;
  border: none;
  outline: none;
  font-size: 13px;
  color: #111827;
  background: transparent;
  font-family: inherit;
  padding: 2px 0;
}

.chip-array-input__error {
  font-size: 11px;
  color: #d32f2f;
  margin: 0;
}

.chip-array-input__hint {
  font-size: 11px;
  color: #9ca3af;
  margin: 0;
}

.chip-array-input__hint kbd {
  font-family: "SFMono-Regular", Consolas, monospace;
  font-size: 10px;
  background: #f3f4f6;
  border: 1px solid #d1d5db;
  border-radius: 3px;
  padding: 1px 4px;
  color: #374151;
}
`, "",{"version":3,"sources":["webpack://./src/components/shared/ChipArrayInput/ChipArrayInput.css"],"names":[],"mappings":"AAAA,+EAA+E;;AAE/E;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,SAAS;AACX;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,eAAe;EACf,mBAAmB;EACnB,QAAQ;EACR,gBAAgB;EAChB,iBAAiB;EACjB,yBAAyB;EACzB,kBAAkB;EAClB,YAAY;EACZ,gBAAgB;EAChB,gDAAgD;AAClD;;AAEA;EACE,qBAAqB;EACrB,4CAA4C;AAC9C;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,SAAO;EACP,gBAAgB;EAChB,YAAY;EACZ,aAAa;EACb,eAAe;EACf,cAAc;EACd,uBAAuB;EACvB,oBAAoB;EACpB,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,SAAS;AACX;;AAEA;EACE,eAAe;EACf,cAAc;EACd,SAAS;AACX;;AAEA;EACE,kDAAkD;EAClD,eAAe;EACf,mBAAmB;EACnB,yBAAyB;EACzB,kBAAkB;EAClB,gBAAgB;EAChB,cAAc;AAChB","sourcesContent":["/* ── ChipArrayInput ──────────────────────────────────────────────────────── */\n\n.chip-array-input {\n  display: flex;\n  flex-direction: column;\n  gap: 4px;\n}\n\n.chip-array-input__label {\n  font-size: 12px;\n  font-weight: 600;\n  color: #374151;\n  margin: 0;\n}\n\n.chip-array-input__required {\n  color: #d32f2f;\n}\n\n.chip-array-input__field {\n  display: flex;\n  flex-wrap: wrap;\n  align-items: center;\n  gap: 6px;\n  min-height: 40px;\n  padding: 6px 10px;\n  border: 1px solid #d1d5db;\n  border-radius: 8px;\n  cursor: text;\n  background: #fff;\n  transition: border-color 0.15s, box-shadow 0.15s;\n}\n\n.chip-array-input__field:focus-within {\n  border-color: #00a651;\n  box-shadow: 0 0 0 2px rgba(0, 166, 81, 0.15);\n}\n\n.chip-array-input--error .chip-array-input__field {\n  border-color: #d32f2f;\n}\n\n.chip-array-input__text {\n  flex: 1;\n  min-width: 140px;\n  border: none;\n  outline: none;\n  font-size: 13px;\n  color: #111827;\n  background: transparent;\n  font-family: inherit;\n  padding: 2px 0;\n}\n\n.chip-array-input__error {\n  font-size: 11px;\n  color: #d32f2f;\n  margin: 0;\n}\n\n.chip-array-input__hint {\n  font-size: 11px;\n  color: #9ca3af;\n  margin: 0;\n}\n\n.chip-array-input__hint kbd {\n  font-family: \"SFMono-Regular\", Consolas, monospace;\n  font-size: 10px;\n  background: #f3f4f6;\n  border: 1px solid #d1d5db;\n  border-radius: 3px;\n  padding: 1px 4px;\n  color: #374151;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
